<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.75 2V6M3.8501 2V6M4.25 2V6M5.25 2V6M1 1H7V7H1V1Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linejoin="round"
    />
  </svg>
</template>
